const  Role = {
    Admin: 'Admin',
    User: 'User',
    Super_Admin:'SUPER-ADMIN'    
};
export default Role;